// Object.hasOwn polyfill for older browsers
if (!Object.hasOwn) {
  Object.hasOwn = function (obj: any, prop: string | number | symbol) {
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }
}
